module.exports = __webpack_public_path__ + "img/9.337d200f.png";